import { useTranslation } from 'react-i18next'

import { QA_NAME_PROFILE_TABS_SECTION } from '../../../constants/qa'
import { Divider } from '../../Divider'
import { EntityProfileTabsLoading } from '../../Entity'
import { TabScrollList } from '../../Tab'
import { useRequestProfileContext } from '../RequestProfile.hooks'

import { useRequestProfileTabsActiveTab } from './RequestProfileTabs.hooks'
import {
  getActiveTabContent,
  getRequestProfileTabs,
} from './RequestProfileTabs.utils'

import * as styles from './RequestProfileTabs.module.css'

function RequestProfileTabs({
  counters,
  handleLoadCounters,
  isCountersReady,
  requestData,
}) {
  const { t } = useTranslation()

  const { isInitiated } = useRequestProfileContext()

  const preparedTabs = getRequestProfileTabs({
    countersMap: counters,
    isCountersLoading: !isCountersReady,
    requestData,
    t,
  })

  const { activeTabId, handleSetActiveTab } = useRequestProfileTabsActiveTab({
    preparedTabs,
    requestData,
  })

  const activeTabContent = getActiveTabContent({
    activeTabId,
    handleLoadCounters,
  })

  return !isInitiated ? (
    <>
      <Divider className={styles.divider} />
      <EntityProfileTabsLoading tabsClassName={styles.tabsWrapper} />
    </>
  ) : requestData && preparedTabs.length > 0 ? (
    <>
      <Divider className={styles.divider} />
      <TabScrollList
        activeTab={activeTabId}
        preparedTabs={preparedTabs}
        sectionQaName={QA_NAME_PROFILE_TABS_SECTION}
        tabProps={{
          className: styles.tab,
        }}
        wrapperClassName={styles.tabsWrapper}
        onSetActiveTab={handleSetActiveTab}
      />
      {activeTabContent}
    </>
  ) : null
}

export default RequestProfileTabs
